import './index.scss';
import { useTheme } from '../ThemeProvider'
import { useMemo } from 'react'
import { Avatar } from '../../components';

const SOCIALS = [
  {
    name: 'linkedin',
    href: 'https://www.linkedin.com/in/eizy-chen-804733246/',
  },
  {
    name: 'github',
    href: 'https://github.com/eizyc',
  },
  {
    name: 'wechat',
    href: './wechat.JPG',
  },
  {
    name: 'email',
    href: 'mailto:eizyc66@gmail.com',
  }
]

function Home() {
  const { theme } = useTheme();
  const isDarkMode = useMemo(() => theme==='dark', [theme])
  const iconMode = useMemo(() => isDarkMode?'fill':'outline', [isDarkMode])

  const renderSocials = () => SOCIALS.map(({name, href},idx)=>(
    <a target="_blank" href={href} key={name} rel="noreferrer" style={{'--i':idx+1}}>
      <i className={`iconfont icon-${name}-${iconMode}`}></i>
    </a>
  ))

  return (
    <div className='home' id='home'>
      <div className='content'>
        <p className='title'>Hello, I’m <b>Eizy</b> ! <span className='hello'>👋</span></p>
        <div className='sub_title'>
          <p>Frontend & Fullstack Developer</p>
          <p>๐•ᴗ•๐</p>
        </div>
        <div className='socials'>
          {renderSocials()}
        </div>
      </div>
      <div className='portrait'>
        <Avatar/>
      </div>
    </div>
  );
}
export default Home;
